<template>
  <SysDirCommon :dir-name="'课程目录'" :dir-def-id="'inner_train'" :query-id="'iht_course_manage'"></SysDirCommon>
</template>

<script>

import SysDirCommon from "@/views/applications/sys/SysDirCommon.vue";
export default {
  name: "CourseManage",
  components: {SysDirCommon},
  computed: {},
  data(){
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
@import 'src/global';


</style>